import React, { useState } from 'react';
import { CheckIcon, SmallCloseIcon, TriangleDownIcon } from '@chakra-ui/icons';
import { Box, Icon, IconButton, Input, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react';
import { RiPencilFill } from 'react-icons/ri';
import { ParkMenuItems } from './ParkMenuItems';

export function GroupTab({ group, onRemoveGroup, isTabActive, saveGroup, canDelete }) {
    const [showEditGroupName, setShowEditGroupName] = useState(false);
    const [inputValue, setInputValue] = useState(group.name);

    const handleSaveGroupName = () => {
        saveGroup(group.groupId, { name: inputValue });
        setShowEditGroupName(false);
    };

    return (
        <>
            {isTabActive ? (
                <Menu closeOnSelect={false}>
                    <MenuButton
                        as={IconButton}
                        data-testid="group-tab-menu-button"
                        icon={<TriangleDownIcon w={3} h={3} />}
                        variant="ghost"
                        size="sm"
                        color="grayDark"
                    />

                    <MenuList minWidth="240px" data-testid="group-tab-menu-list">
                        {showEditGroupName ? (
                            <Box
                                display="flex"
                                color="white50"
                                p={0.5}
                                _hover={{ backgroundColor: 'grayDark' }}
                                borderBottom="1px solid var(--chakra-colors-black)">
                                <Input
                                    size="sm"
                                    defaultValue={inputValue}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    onKeyDown={(e) => {
                                        e.stopPropagation();

                                        if (e.key === 'Enter') {
                                            handleSaveGroupName();
                                        }
                                    }}
                                    borderColor="grayDark3"
                                    backgroundColor="grayDark2"
                                    data-testid="group-tab-edit-input"
                                />
                                <IconButton
                                    icon={<CheckIcon />}
                                    as="div"
                                    size="sm"
                                    onClick={handleSaveGroupName}
                                    data-testid="group-tab-save-button"
                                    ml={0.5}
                                />
                            </Box>
                        ) : (
                            <MenuItem color="white50" onClick={() => setShowEditGroupName(true)}>
                                <Box py={0.5} pr="6px" display="inherit">
                                    <Icon as={RiPencilFill} boxSize={5} />
                                </Box>
                                <Text fontWeight="bold" color="white50" as="span">
                                    EDIT GROUP NAME
                                </Text>
                            </MenuItem>
                        )}

                        <ParkMenuItems group={group} saveGroup={saveGroup} />
                    </MenuList>
                </Menu>
            ) : (
                <Box width={8} />
            )}
            {group.name}
            {isTabActive && canDelete ? (
                <IconButton
                    onClick={onRemoveGroup}
                    icon={<SmallCloseIcon w={5} h={5} />}
                    variant="ghost"
                    size="sm"
                    color="grayDark"
                    data-testid="group-tab-remove-button"
                />
            ) : (
                <Box width={8} />
            )}
        </>
    );
}
